import { gql } from '@apollo/client';
export const CONFIG = gql `
  query CONFIG {
    config {
      segmentKey
      segmentProxyUrl
      segmentTrackingOneTrustGroupIds
      weglotApiKey
      logoutShowModalExpireSec
      logoutActionExpireSec
      logoutKeepAliveIntervalSec
      guildStartPageUrl
      sierraAgentToken
      env
    }
  }
`;
